import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import ClassNames from "classnames"

import Styles from "./../validation.less"

export default createReactClass({
  propTypes: {
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  },
  getValue() {
    return typeof this.props.value == "array" ? this.props.value[0] || "" : this.props.value
  },
  getClass() {
    return ClassNames(Styles.message, this.props.className)
  },
  render() {
    return <span className={this.getClass()}>{this.getValue()}</span>
  },
})
